// Identity this frontend declares to the backend on every request.
//
// X-Client (#350) makes the client kind explicit instead of leaving the backend to
// deduce it from the user agent. X-Client-Version (#351) carries the build that is
// running, so an error can be traced back to the exact code that produced it: the
// deployed commit on Netlify (COMMIT_REF), the working-tree HEAD locally, injected
// at build time by vite.config.ts.
export const CLIENT_NAME = "web";

export const CLIENT_VERSION = __CLIENT_VERSION__;

export const CLIENT_HEADERS = {
  "X-Client": CLIENT_NAME,
  "X-Client-Version": CLIENT_VERSION,
} as const;
